import queryString from "query-string";

/**
 * Parses URL search string into an object.
 * @param {string} search - URL search string (e.g., "?foo=bar")
 * @returns {Object} Parsed key-value pairs
 */
export function parseSearchParams(search) {
  return queryString.parse(search);
}

/**
 * Builds the search string updateSearchParams would navigate to, without
 * navigating. Callers use this to skip a redundant navigate when the URL already
 * says what they were about to write.
 *
 * @param {Object} paramsToUpdate - Key-value pairs to set in URL
 * @returns {string} Search string including the leading "?", or "" when empty
 */
export function buildSearchString(paramsToUpdate) {
  const params = {};

  Object.entries(paramsToUpdate).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params[key] = Array.isArray(value) ? value.join(",") : value;
    }
  });

  const query = queryString.stringify(params);
  return query ? `?${query}` : "";
}

/**
 * Updates URL search params and navigates with replace.
 * @param {Object} location - React Router location object
 * @param {Function} navigate - React Router navigate function
 * @param {Object} paramsToUpdate - Key-value pairs to set in URL
 */
export function updateSearchParams(location, navigate, paramsToUpdate) {
  navigate(`${location.pathname}${buildSearchString(paramsToUpdate)}`, {
    replace: true,
  });
}
